export default __webpack_public_path__ + "static/media/logos.4a69a801.png";